import React from 'react';
import { useStatistics } from './StatiscticsContext';
import ColorDistributionBar from '../V3/Statistics/_components/ColorDistributionBar';
import { getColor, getPercent } from '../V3/Statistics/_utils';
import { PeriodStoreListContainerProps, SalesStore } from '@/types/statistics';
import { cn } from '@/utils/tailwind';
import Badge from '@/components/V3/Badge';
import { autoComma } from '@/utils/parser';
const StoreChartSection = () => {
  const { activedMonthlySales, salesStoreList, isRegisteredMarket, totalSalesAmount } =
    useStatistics();

  const showOverlay = !isRegisteredMarket || totalSalesAmount === 0;
  const displayList = showOverlay ? MOCK_SALES_STORE_LIST : salesStoreList;
  const totalAmount = showOverlay
    ? MOCK_SALES_STORE_LIST.reduce((sum, cur) => sum + cur.SalesAmount, 0)
    : activedMonthlySales.SalesAmount;

  return (
    <div className="flex h-[268px] flex-col gap-4 rounded-[16px] bg-white p-[16px]">
      <div className="text-gr-900 Body1S16">스토어별 매출</div>
      <ColorDistributionBar
        PcVersion
        salesItemList={displayList}
        activedMonthlySalesAmount={totalAmount}
      />
      <div className="scrollbar flex flex-1 flex-col gap-[20px] overflow-y-auto pb-[20px]">
        {displayList.map((item: SalesStore, index) => {
          const { background, border } = getColor(index);
          const percentValue = getPercent(item.SalesAmount, totalAmount);
          return (
            <div
              className="flex items-center justify-between"
              key={`${item.StoreName} ${item.SalesAmount} ${index}`}
            >
              <div className="flex items-center gap-[10px]">
                <div
                  className={cn('h-[10px] w-[10px] rounded-[5px] border-[1px]', background, border)}
                />
                <div className="flex items-center gap-[4px]">
                  <div className="line-clamp-2 max-w-[95px] break-all text-gr-800 Body5M14">
                    {item.StoreName}
                  </div>
                  <Badge variant={'gray'} height={'26'} width={'6'}>
                    {item.MarketName}
                  </Badge>
                </div>
              </div>
              <div className="text-v3-gr-800 Body5M14">{`${autoComma(
                item.SalesAmount,
              )}원 (${percentValue}%)`}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default StoreChartSection;

// StoreChartSection 상단에 선언
const MOCK_SALES_STORE_LIST = [
  {
    MarketIconUrl:
      'https://cplat-images.s3.ap-northeast-2.amazonaws.com/sellerbox/market-icon/IconMarketSmartstore.png',
    MarketName: '스마트스토어',
    SalesAmount: 111804660,
    SalesCount: 129,
    StoreName: '셀러박스',
  },
  {
    MarketIconUrl:
      'https://cplat-images.s3.ap-northeast-2.amazonaws.com/sellerbox/market-icon/IconMarket11st.png',
    MarketName: '11번가',
    SalesAmount: 108161010,
    SalesCount: 63,
    StoreName: '11번가',
  },
  {
    MarketIconUrl:
      'https://cplat-images.s3.ap-northeast-2.amazonaws.com/sellerbox/market-icon/IconMarketGmarket.png',
    MarketName: 'G마켓',
    SalesAmount: 23880490,
    SalesCount: 22,
    StoreName: '지마켓',
  },
  {
    MarketIconUrl:
      'https://cplat-images.s3.ap-northeast-2.amazonaws.com/sellerbox/market-icon/IconMarketAuction.png',
    MarketName: '옥션',
    SalesAmount: 2245525,
    SalesCount: 3,
    StoreName: '옥션',
  },
];
